import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListChallengeTranslationsRequest } from './list-challenge-translations-request';
import type { IListChallengeTranslationsResponse } from './list-challenge-translations-response';
import { listChallengeTranslationsResponseSchema } from './list-challenge-translations-response';

export async function listChallengeTranslationsApi({
  challengeId,
}: IListChallengeTranslationsRequest): Promise<
  IValidatedResponse<IListChallengeTranslationsResponse>
> {
  return getRequest<IListChallengeTranslationsResponse>({
    path: `/sys/challenges/${challengeId}/translations`,
    schema: listChallengeTranslationsResponseSchema,
  });
}
